<template>
  <div id="app">
	<Pc2></Pc2>
  </div>
</template>

<script>
import Pc2 from './views/pc2.vue'
export default {
  name: 'app',
  components: {
	Pc2
  }
}
</script>

<style lang="scss">
@import './style/font.css';
@import './style/fullpage.css';
* {
	margin: 0;
	padding: 0;
}
#app {
  margin: 0;
  height: 100vh;
  padding: 0;
  
}
</style>
